/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/prop-types */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useSelector } from 'react-redux';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';

// UI Components
import ZodiacProductItem from '../../../GraphqlCommonComponents/TrendingProducts/Partials/ZodiacProductItem';
import SimpleProductSkeleton from '../../../GraphqlSkeletonComponents/SimpleProductSkeleton';
import useStyles from './ZodiacCollectionStyles';

// helpers, redux, queries
import {
    getUserSubmittedProductFilterZipcode, getLocationType, getIsBot, getCurrencyData,
} from '../../../../../../state/ducks/App/App-Selectors';
import { GRAPHQL_ENV } from '../../../../../gql';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import findCategoryPageByURL from '../../../../../gql/queries/findCategoryPageByURL';

const ZodiacCollection = ({
    signsMetaData, selectedSign, isSmallScreen,
}) => {
    const styles = useStyles();

    // useSelector
    const isBot = useSelector(getIsBot);
    const brand = useSelector(getBrand);
    const userSubmittedZip = useSelector(getUserSubmittedProductFilterZipcode);
    const locationType = useSelector(getLocationType);
    const currency = useSelector(getCurrencyData);

    const {
        collection_url, date, description, icon, title,
    } = signsMetaData;

    const CATEGORY_PAGE_QUERY = findCategoryPageByURL(brand.domain, collection_url, 'standard_collections', userSubmittedZip, locationType, isBot, currency.currencyName);

    const getTitleAndDate = () => (
        <>
            <span
                className={`${styles.zodiacCollection} center-alignment title-container`}
                role="main"
            >
                <h2 className={`${styles.zodiacCollection} title`}>
                    <img src={icon?.url} alt={title} /> {title}
                </h2>
            </span>
            <p
                role="contentinfo"
                className={`${styles.zodiacCollection} center-alignment date`}
            >
                {date}
            </p>
        </>
    );
    /* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ] */
    return (
        <div className="container mt-4 mb-2">
            <div>
                {getTitleAndDate()}
            </div>
            <Grid>
                {description && (
                    <div className={`${styles.zodiacCollection} description`}>
                        {isSmallScreen ? (
                            <>
                                <input
                                    type="checkbox"
                                    className="read-more-state"
                                    id="post-1"
                                />
                                <div className="OurStory-p text-center read-more-wrap">
                                    <span className="first-content mb-1">
                                        {description.substring(0, 140)}
                                    </span>
                                    <span className="read-more-target second-content pb-1">
                                        {description.substring(
                                            140,
                                            description
                                                .length,
                                        )}
                                    </span>
                                </div>
                                <label
                                    htmlFor="post-1"
                                    className="read-more-trigger"
                                    aria-label="Read More/Read Less"
                                />
                            </>
                        ) : (
                            <>{description}</>
                        )}
                    </div>
                )}
            </Grid>
            <Query query={CATEGORY_PAGE_QUERY} fetchPolicy="cache-and-network">
                {({ loading, data, error }) => {
                    if (loading) {
                        return <SimpleProductSkeleton />;
                    }

                    if (error) {
                        mbpLogger.logError({
                            query: CATEGORY_PAGE_QUERY,
                            component: 'ZodiacCollection.js',
                            message: 'Error executing findCategoryPageByUrl query',
                            env: GRAPHQL_ENV,
                            error,
                        });
                        return null;
                    }

                    if (!data) {
                        mbpLogger.logWarning({
                            query: CATEGORY_PAGE_QUERY,
                            component: 'ZodiacCollection.js',
                            message: 'No data returned for Category Page Query',
                            env: GRAPHQL_ENV,
                        });
                        return null;
                    }
                    const categoryData = data?.findCategoryPageByUrl;
                    // Set category name and shortDescription for Google Analytics' ec:impression name
                    if (categoryData?.category && categoryData.content?.entries?.[0]?.name) {
                        const categoryName = categoryData.content.entries[0].name;
                        if (!categoryData.category.name) {
                            categoryData.category.name = categoryName;
                        }
                        if (!categoryData.category.shortDescription) {
                            categoryData.category.shortDescription = categoryName;
                        }
                    }
                    mbpLogger.logInfo({
                        message: 'data returned from collection page query',
                    });
                    const refineCollection = categoryData?.category?.products?.slice(0, 4);
                    return (
                        <Grid container spacing={2}>
                            {refineCollection?.map((item, index) => (
                                <Grid key={item.id} item md={3} xs={6} className="product-container" index={index}>
                                    <div>
                                        <div>
                                            <ZodiacProductItem
                                                isFromCart={false}
                                                item={{ ...item }}
                                                key={item.id}
                                                gridCount={4}
                                                isWrapUpProduct={false}
                                                isSmallScreen={isSmallScreen}
                                                selectedSign={selectedSign}
                                                isCollection
                                                isZodiacProduct
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    );
                }}
            </Query>
        </div>
    );
};

ZodiacCollection.propTypes = {};

export default ZodiacCollection;
